export default {
	News: "/",
	CarbonFootprint: "/carbon-footprint",
	Articles: "/articles",
	Post: ( id = ":id" ) => `/post/${ id }`
}